export default "__VITE_ASSET__CTXM4UeE__"